// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"661f0128","239":"ce3ea730","732":"2dcead0a"}[chunkId] + ".chunk.js";
};